import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ng-rooster',
  template: `
    <p>
      ng-rooster works!
    </p>
  `,
  styles: []
})
export class NgRoosterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
